
import { mapState, mapActions } from 'vuex'
import NrSelect from '@nextrequestco/components/src/components/NrSelect/nr-select.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrEditor from '@nextrequestco/components/src/components/NrEditor/nr-editor.vue'
import { debounce } from 'lodash'
import NrFormSelect from '@nextrequestco/components/src/components/NrFormSelect/nr-form-select'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements/nr-form-label.vue'
import {
  RequestVisibility,
  accountRequestVisibilities
} from '../../../store/globalModule'

interface ClosureTemplate {
  id: number
  label: string
  description: string
}

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  components: { NrModal, NrEditor, NrFormSelect, NrSelect, NrFormLabel },
  data() {
    return {
      selectedClosureTemplates: [],
      templates: [],
      closureText: '',
      selectedRequestVisibility: '',
      closureReasonsPageNumber: 1,
      closureReasonsHasMore: true
    }
  },
  mounted() {
    this.setupCurrentReqVisiOption()
    this.fetchClosureTemplates()
  },
  methods: {
    ...mapActions('request_show', ['fetchClosureTemplates']),
    setClosureTemplate(temp: ClosureTemplate[]): void {
      if (!temp) {
        this.closureText = ''
        return
      }

      this.closureText = temp
        .map((template) => template.description)
        .join('<br />')
    },
    filterClosureTemplates: debounce(function (temp: string): void {
      this.closureReasonsPageNumber = 0
      this.fetchClosureTemplates({
        search_text: temp,
        page_number: this.closureReasonsPageNumber
      }).then((hasMore) => {
        this.closureReasonsHasMore = hasMore
      })
    }, 300),
    loadMoreClosureTemplates: debounce(function (temp: string): void {
      this.closureReasonsPageNumber += 1
      this.fetchClosureTemplates({
        search_text: temp,
        page_number: this.closureReasonsPageNumber
      }).then((hasMore) => {
        this.closureReasonsHasMore = hasMore
      })
    }, 300),
    setupCurrentReqVisiOption(): void {
      const visi = this.reqVisibilities.find(
        (el: RequestVisibility) => el.value === this.request.visibility
      )
      this.selectedRequestVisibility = visi?.value
    },
    submitForm(): void {
      const params = {
        pretty_id: this.request.pretty_id
      }
      if (this.selectedRequestVisibility) {
        Object.assign(params, {
          visibility: this.selectedRequestVisibility
        })
      }
      if (this.selectedClosureTemplates.length) {
        Object.assign(params, {
          close_description: this.closureText ? this.closureText : '',
          close_reasons: this.selectedClosureTemplates.map(
            (template) => template.id
          )
        })
      } else {
        this.$toasted.error('You must select a reason for closing the request')
        return
      }
      this.$emit('on-submit', params)
    }
  },
  watch: {
    active(isActive) {
      if (isActive) {
        this.setupCurrentReqVisiOption()
      }
    }
  },
  computed: {
    ...mapState(['account']),
    ...mapState('request_show', ['request', 'closureTemplates']),
    reqVisibilities(): RequestVisibility[] {
      return accountRequestVisibilities(this.account)
    }
  }
}
